import React from 'react'
import PagesHeading from '../components/PagesHeading'
import AboutHeadCard from '../components/AboutHeadCard'
import QuoteCard from '../components/QuoteCard'
import ValuesSection from '../components/ValuesSection'
import Team from '../components/Team'
import CEOSection from '../components/CEOSection'

const About = () => {
    return (
        <div className='mt-10 sm:mt-0'>
            <PagesHeading heading="About Us" />
            <div className="flex flex-col  justify-center p-4 sm:p-6 md:p-8 lg:p-10 max-w-7xl mx-auto gap-y-10 mt-2 sm:mt-4 md:mt-8 lg:mt-10">
                 <CEOSection/>
                <AboutHeadCard />
               
                <QuoteCard title="Our Mission" quote="To deliver next-generation web, mobile, and AI-driven solutions that redefine user experience, automate complexity, and unlock boundless potential for global enterprises through technology that thinks, adapts, and evolves" />
                <QuoteCard title="Our Vision" quote="To pioneer the future of intelligent digital transformation by merging innovation, design, and autonomous AI — empowering businesses to operate smarter, faster, and more humanly" />
                <ValuesSection />
                <Team />
            </div>
        </div>
    )
}

export default About